import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TMarketplaceProduct } from './types';

type MarketplaceProductsResponse = {
  data: TMarketplaceProduct[];
};

type UseMarketplaceProductsParams = {
  includeVendors?: boolean;
  includePricingVariants?: boolean;
};

export function useMarketplaceProducts(params?: UseMarketplaceProductsParams) {
  const queryParams = new URLSearchParams();

  if (params?.includeVendors !== undefined) {
    queryParams.append(
      'includeVendors',
      params.includeVendors ? 'true' : 'false'
    );
  }

  if (params?.includePricingVariants !== undefined) {
    queryParams.append(
      'includePricingVariants',
      params.includePricingVariants ? 'true' : 'false'
    );
  }

  const queryString = queryParams.toString();
  const url = queryString
    ? `marketplace/products?${queryString}`
    : 'marketplace/products';

  const {
    data,
    error,
    mutate,
  }: {
    data?: MarketplaceProductsResponse;
    error?: unknown;
    mutate: KeyedMutator<MarketplaceProductsResponse>;
  } = useSWR(
    url,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data: data?.data || [],
    error,
    mutate,
  };
}
